export const getProductDisplayName = item => {
  const enTranslator = item?.productTranslators?.find(t => t.lang === 'en');
  return enTranslator?.name || item?.internationalCode || item?.url || '';
};

export const getProductsList = (list, previouslyAddedProducts) => {
  const dropdownList = [];
  if (list?.length) {
    list.forEach(item => {
      const productKey = item.key;
      const productName = getProductDisplayName(item);
      const { priceValue: previouslyAddedValue, discountTypeId } =
        previouslyAddedProducts.find(product => product?.productKey === productKey) || {};

      dropdownList.push({
        prevValue: previouslyAddedValue,
        productName,
        productKey,
        productPrevType: discountTypeId,
        mainImageUrl: item.mainImageUrl,
      });
    });
  }
  return dropdownList;
};

export const createQueryParam = (key, list) => {
  let query = '';
  list?.forEach(item => {
    if (!query) {
      query = `${key}=${item}`;
    } else {
      query = `${query}&${key}=${item}`;
    }
  });
  return query;
};
